async function disableBMSMonSubscriptionLineItem() {
  // Check if cart and cart.items exist
  if (!Rebuy?.Cart?.cart?.items) {
    return; // Exit early if cart or items are undefined
  }

  const cartItems = Rebuy.Cart.cart.items;

  for (const [index, cartItem] of cartItems.entries()) {
    const thisItemsQuantitySelectorElement = document.querySelectorAll(
      ".rebuy-cart__flyout-item-quantity"
    )[index];

    // Prevent a subscription item from having more than 1 quantity
    if (cartItem?.product?.subscription && cartItem.quantity > 1) {
      // Set Quantity to 1
      await Rebuy.Cart.changeItem({ id: cartItem.id, quantity: 1 });
    }
    // Hide quantity selectors
    if (cartItem?.product?.subscription) {
      thisItemsQuantitySelectorElement.style.opacity = "0";
      thisItemsQuantitySelectorElement.style.pointerEvents = "none";
    } else {
      // Un-Hide quantity selectors if not a subscription item
      thisItemsQuantitySelectorElement.style.opacity = "1";
      thisItemsQuantitySelectorElement.style.pointerEvents = "all";
    }
  }
}

// Event listener for cart changes
document.addEventListener("rebuy:cart.change", (event) => {
  setTimeout(() => {
    disableBMSMonSubscriptionLineItem();
  }, 500);
});

// Initial call with delay
setTimeout(() => {
  disableBMSMonSubscriptionLineItem();
}, 2000);

document.addEventListener("DOMContentLoaded", function() {
  // Select all elements that match the CSS selector
  var elements = document.querySelectorAll("a.iLj45AlE0f4g64las.vwo_add-to-cart");

  // Function to be executed after the delay
  function delayedFunction() {
    setTimeout(function() {
       // Call your function after 1.5 seconds
    // drawerfunction(2);      
    }, 1000); // 1500 milliseconds = 1.5 seconds
  }
  function delayedFunctionnew() {
    setTimeout(function() {
       // Call your function after 1.5 seconds          
       $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble>*",""); 
       $("cart-drawer").load(location.href + " cart-drawer>*",""); 
       drawerfunction(2);
       $("#cart-icon-bubble")[0].click();
    }, 3000); // 1500 milliseconds = 1.5 seconds
  }

  // Loop through each element and attach the event listener
  elements.forEach(function(element) {
    element.addEventListener("click", function(event) {
      event.preventDefault()
      delayedFunction();
      delayedFunctionnew();
      // Call the delayed function on click
    });
  });
});

$(document).ready(function(){

// $('.skio-group-title').each(function () {
//   var $el = $(this);
//   var textOnly = $el.clone()      // Clone to avoid modifying the DOM
//                      .children()  // Remove child elements (like script)
//                      .remove()
//                      .end()
//                      .text()
//                      .trim();

//   if (textOnly.includes('--')) {
//     var parts = textOnly.split('--');

//     // Remove the original text node only
//     $el.contents().filter(function () {
//       return this.nodeType === 3 && this.nodeValue.includes('--');
//     }).remove();

//     // Prepend the new <p> elements
//     $el.prepend('<p class="desc-sub">' + parts[1].trim() + '</p>');
//     $el.prepend('<p>' + parts[0].trim() + '</p>');
//   }
// });
  
$(".prod-temp-new-pdp-2_0 .product__info-container .product__accordion").each(function(){
    if($(this).find(".accordion__content").html().trim() === ""){
        $(this).hide();
    }
});
//   setInterval(function() {
//   if ($("#rebuy-modal .rebuy-notification-dialog-button.rebuy-button.primary").length > 0) {
//     $("#rebuy-modal .rebuy-notification-dialog-button.rebuy-button.primary").click();
//   }
// }, 500);

  if($('body').hasClass('index') || $('body').hasClass('collection') || $('body').hasClass('product') || $('body').hasClass('sale-collection') || $('body').hasClass('customize-your-own-bundle') || $('body').hasClass('fragrance-bundle-page')){
   var anno_height = $('.announcement-bar-section').outerHeight();
    var header_height = $('.header-wrapper').outerHeight();
    var topmenu_height = $('.top-menu-collection-section').outerHeight();
    var sub_total = header_height + topmenu_height + anno_height - 2;   
     var ah_total = header_height + anno_height;   
    $('main#MainContent').css('margin-top', sub_total);
    $('.top-menu-collection-section').css('top', ah_total - 1);
  }else{    
    var header_height = $('.header-wrapper').outerHeight();    
    $('main#MainContent').css('margin-top', header_height);
  }
  
  $maxHeight = 0;
  $("header .mega-menu-content .mega-menu-img-content").css('height', '');
  $("header .mega-menu-content .mega-menu-img-content").each(function(){
    if($(this).height() > $maxHeight) {
      $maxHeight = $(this).height();
    }
  });
  $("header .mega-menu-content .mega-menu-img-content").height($maxHeight);
 
 
  //  $maxHeight1 = 0; 
  // $("header .mega-menu-content .parent-image-menu img").css('height', '');
  // $("header .mega-menu-content .parent-image-menu img").each(function(){
  //   if($(this).height() > $maxHeight1) {
  //     $maxHeight1 = $(this).height();
  //   }
  // });
  // $("header .mega-menu-content .parent-image-menu img").height($maxHeight1);
  
  $maxHeight2 = 0; 
  $("header .mega-menu-content .right-image-desc a.link-btn").css('height', '');
  $("header .mega-menu-content .right-image-desc a.link-btn").each(function(){
    if($(this).height() > $maxHeight2) {
      $maxHeight2 = $(this).height();
    }
  });

  var h = $maxHeight2 + 8;
  $("header .mega-menu-content .parent-image-menu img").css( { height: 'calc(100% - ' + h + 'px)' } );
  
  $(window).resize(function(){   

     if($('body').hasClass('index') || $('body').hasClass('collection') || $('body').hasClass('product') || $('body').hasClass('sale-collection') || $('body').hasClass('customize-your-own-bundle') || $('body').hasClass('fragrance-bundle-page')){
   var anno_height = $('.announcement-bar-section').outerHeight();
    var header_height = $('.header-wrapper').outerHeight();
    var topmenu_height = $('.top-menu-collection-section').outerHeight();
    var sub_total = header_height + topmenu_height + anno_height - 2;   
     var ah_total = header_height + anno_height;   
    $('main#MainContent').css('margin-top', sub_total);
    $('.top-menu-collection-section').css('top', ah_total - 1 );
  }else{    
    var header_height = $('.header-wrapper').outerHeight();    
    $('main#MainContent').css('margin-top', header_height);
  }
    
    
    //  $maxHeight1 = 0;
    //  $("header .mega-menu-content .parent-image-menu img").css('height', '');
    // $("header .mega-menu-content .parent-image-menu img").each(function(){
    //   if($(this).height() > $maxHeight1) {
    //     $maxHeight1 = $(this).height();
    //   }
    // });
    // $("header .mega-menu-content .parent-image-menu img").height($maxHeight1);
    
    $maxHeight = 0;
    $("header .mega-menu-content .mega-menu-img-content").css('height', '');
    $("header .mega-menu-content .mega-menu-img-content").each(function(){
      if($(this).height() > $maxHeight) {
        $maxHeight = $(this).height();
      }
    });
    $("header .mega-menu-content .mega-menu-img-content").height($maxHeight);

     $maxHeight2 = 0; 
  $("header .mega-menu-content .right-image-desc a.link-btn").css('height', '');
  $("header .mega-menu-content .right-image-desc a.link-btn").each(function(){
    if($(this).height() > $maxHeight2) {
      $maxHeight2 = $(this).height();
    }
  });

  var h = $maxHeight2 + 8;
  $("header .mega-menu-content .parent-image-menu img").css( { height: 'calc(100% - ' + h + 'px)' } );
  });

// $("#MainContent").removeClass("temp-index-main");
// if ($(this).scrollTop() > 100) { // this refers to window
//      $("body").addClass("sticky-cart-drawer-wrap");
//     }

  $('.left-heading-desc .button[href="#footer"]').on('click',function () {
     $(this).parents('.mega-menu-content').prev().addClass('mouseleave');
    
  });

  $('.header .link-with-hover').hover(function(){
   $('.link-with-hover').removeClass('mouseleave');
  });
  
  $('.header_drawer_close').on('click',function () {
    $('.menu-drawer-container .header__icon--menu').trigger('click')
  });
// Cart Drawer Outside click
  $(document).on('mousedown', function(event) {
      // Check if .drawer.active is present
      if ($('.drawer.active').length > 0) {
          var drawer = $('.drawer__inner');
          var quickView = $('.quickview_dialog');    
          if (!drawer.is(event.target) && drawer.has(event.target).length === 0 && !quickView.is(event.target) && quickView.has(event.target).length === 0) {
              $('.drawer__close').trigger('click');
          }
      }
  });

  $('.quickview_close').click(function(event) {
    if ($('.quickview_dialog').css('display') === 'block') {
      $('.quickview_dialog').hide(); 
    }
  });
// Cart Drawer Outside click

  $(document).on('click', '.cart-remove-button',function() {
// $('.main-cart-drawer').addClass('loading-data');
// setTimeout(function(){
//         $('.main-cart-drawer').removeClass('loading-data');
//       },8000);
    $('.cart-remove-button').attr("disabled", true);
    var varId = $(this).data('variant-id');
    var line = $(this).parent().data('index');
// console.log(varId)
    $.ajax({
            type: 'POST',
            async: false,
            url: '/cart/change.js',
            data: {
                quantity: 0,
                line: line
            },
            dataType: 'json',
            success: function() {
            // console.log('Items added to cart');
            $('cart-drawer').addClass('active');
            $('.product-popup-modal').removeAttr("open");
            $('body').addClass('overflow-hidden');
            $("cart-drawer").load(location.href + " cart-drawer>*","");
            $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
            $('cart-drawer').removeClass('is-empty');
            // $('.main-cart-drawer').removeClass('loading-data');
            // $('.main-cart-drawer .new-product-item').slick('setPosition');
            if($('html').scrollTop() >= 100){
              var height = $('header').outerHeight();
              $('cart-drawer.drawer').css({"top":height+"px", "height":'calc(100% - ' + height + 'px)'});         
             }
           if ($('.cart-count-bubble').not(':visible')) {
               $('cart-drawer').addClass('is-empty');
            }
            },
            error: function() {
                console.log('Error adding items to cart');
            }
        });
  });
  $(document).on("click","header .li-with-drop-down p",function() {
    $(".slider-mobile-drawer").addClass("slider-loading-mobile");
    $(this).parents(".li-with-drop-down").toggleClass("active-dropdown");
    $(this).parents(".li-with-drop-down").find(".mobile-menu-content").slideToggle();
   $('.slider-mobile-drawer ul').slick('slickGoTo', 0);
    setTimeout(function(){
      $(".slider-mobile-drawer").removeClass("slider-loading-mobile");
    },0);
  });
  $('.slider-mobile-drawer ul').slick({
   slidesToShow: 1.56,
  slidesToScroll: 1,
    infinite:false,
    arrows:false,
     responsive: [
    {
      breakpoint: 341,
      settings: {
        slidesToShow: 1.2,
        
      }
    }
       ]
  });

var $slider = $('.review-slider');
  var $progressBar = $('.review-progress');
  var $progressBarLabel = $( '.review_slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 400,
    arrows:false,
    dots:true,
    autoplay: true,
  });  
  
   $(document).on("click","summary.header__icon.header__icon--menu",function() {
     $(".slider-mobile-drawer").addClass("slider-loading-mobile");
     $('.slider-mobile-drawer ul').slick('slickGoTo', 0);
     setTimeout(function(){
      $(".slider-mobile-drawer").removeClass("slider-loading-mobile");
    },0);
   });


$('.habibi-meet-hp-section .habibi-content-slider').slick({
   slidesToShow: 4,
  slidesToScroll: 1,
    infinite:false,
    arrows:false,
     responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        dots:true
        
      }
    },
       {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        dots:true
        
      }
    },
       {
      breakpoint: 750,
      settings: {
        slidesToShow: 1.5,
        dots:true
        
      }
    },
       {
      breakpoint: 481,
      settings: {
        slidesToShow: 1.12,
        dots:true
        
      }
    }
       ]
  });

  //reverse PDP slideshow
   $('.reverse-slideshow .reverse-content-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed:1500,
  infinite:true,
  arrows: false,
  cssEase: 'linear'
});

  //reverse perfume note
$('.reserve-parfume-note-section .reserve-parfume-note-slider').slick({
   slidesToShow: 3,
  slidesToScroll: 1,
    infinite:false,
    arrows:false,
     responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        dots:true
        
      }
    },
       {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        dots:true
        
      }
    },
       {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        dots:true
        
      }
    },
       {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        dots:true
        
      }
    }
       ]
  });
 //main Product page gallery
  if($("body").hasClass("prod-temp-aov-booster-new")){
    var slideshow = 5;
    var showdots= false;
    var showarrow= false;
  }
  else{
    var slideshow = 4
    var showdots= true;
    var showarrow= true;
    
  }

setTimeout(function(){ 
  if($(window).width() > 1199){ 
    if($('.product-slider-nav .slick-slide').length <= 6){
       $('.product-slider-nav').addClass('low-slides');
    }else{
       $('.product-slider-nav').removeClass('low-slides');
    } 
  }else if($(window).width() > 349){
    if($('.product-slider-nav .slick-slide').length <= 4){
       $('.product-slider-nav').addClass('low-slides');
    }else{
       $('.product-slider-nav').removeClass('low-slides');
    } 
  }else{
     $('.product-slider-nav').removeClass('low-slides');
  }
}, 1000);

  $(window).resize(function () {   
    if($(window).width() > 1199){
      if($('.product-slider-nav .slick-slide').length <= 6){
         $('.product-slider-nav').addClass('low-slides');
      }else{
         $('.product-slider-nav').removeClass('low-slides');
      } 
    }else if($(window).width() > 349){
      if($('.product-slider-nav .slick-slide').length <= 4){
         $('.product-slider-nav').addClass('low-slides');
      }else{
         $('.product-slider-nav').removeClass('low-slides');
      } 
    }else{
       $('.product-slider-nav').removeClass('low-slides');
    }
  });
  
$('.product-slider-nav').slick({
  slidesToShow: 6,
  infinite: true,
  asNavFor: '.product-slider-for',
  dots:false,
  arrows: false, 
  vertical:true,
  verticalSwiping: false,
  focusOnSelect: true,
   responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4
        
      }
    },
     {
      breakpoint: 990,
      settings: {
        slidesToShow: 6,
         vertical:false,
      }
    }
   ]
});


 $('.product-slider-for').slick({
    slidesToShow: 1,
    infinite: true, 
    arrows: true, 
    fade: true, 
    dots: false,
    asNavFor: '.product-slider-nav',
   responsive: [
    {
      breakpoint: 749,
      settings: {
        dots: true        
      }
    }
   ]
});
function addBodyClass1() {
     if (!$(".cart_product.new-product-item").hasClass("slick-initialized")) { 
        
        $('.cart_product.new-product-item').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1.15,
        arrows:false     
        });
        $('.cart_product.new-product-item').slick('refresh');
        
      }
  
  }
  setInterval(addBodyClass1, 400);
  function addBodyClass111() {
    if($(".main-cart-drawer").hasClass("active")){
      if(!$(".main-cart-drawer").hasClass("is-empty")){
  if($('.cart_product.new-product-item .slider-card[style="width: 0px;"]').first().length != 0){
    if($(".slider-products-drawer h2").hasClass("open")){
    $('.cart_product.new-product-item.slick-initialized').slick('unslick');
           $('.cart_product.new-product-item').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1.15,
        arrows:false     
        });
        }  
  }
    }
    }
  }
  setInterval(addBodyClass111, 3000);
        // $('.cart_product.new-product-item').slick({
        // dots: false,
        // infinite: false,
        // speed: 300,
        // slidesToShow: 1.15,
        // arrows:false     
        // });
  $('.cart_product.new-product-item').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.15,
      arrows:false     
  });

  $(document).on('click','.quickview_btn', function(e) {
      var d_modal = $(this).attr('data-modal');
      $('#'+d_modal).show();
      $('body').addClass('model_open');
    });
    
    $(document).on('click','.quickview_close', function(e) {      
      $('.quickview_modal').hide();
      $('body').removeClass('model_open');
      $('body').removeClass('overflow-hidden');
      $('body').removeClass('overflow-hidden-tablet');
      
      // if ($("body").find("cart-drawer").length) {
      //   $('cart-drawer').removeClass('active');
      // }
       if ($("body").find("header-drawer").length) {
         $('.header__icon--menu[aria-expanded=true]:before').css('background', 'transparent');
       }
      if($('.drawer').hasClass('active')){
        $('.drawer').addClass('active');
        $('body').addClass('overflow-hidden');
        $('body').addClass('overflow-hidden-tablet');
    }
      
    });

    $(document).on('click','.quick_add_submit', function(e) {
      
    $('.main-cart-drawer').addClass('loading-data');
    e.preventDefault();
       
    $('.quickview_modal').hide();
    $('cart-drawer').removeClass('is-empty');
    $('body').removeClass('model_open');
    var items = [],  main = {       
            quantity: 1,
            id: $(this).parents('product-form').find('.product-variant-id').val()                     
    }          
    items.push(main);
    
    $.ajax({
        type: 'POST',
        async: false,
        url: '/cart/add.js',
        data: {items:items},
        dataType: 'json',
        success: function() {         
          // console.log('Items added to cart');
          
          $("cart-drawer").load(location.href + " cart-drawer>*","");
         $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
          drawerfunction();
         $('.main-cart-drawer').removeClass('loading-data');
        },
        error: function() {
          console.log('Error adding items to cart');
        }
      });
    
  });

   $(document).on('click','.sticky_atc_btn',function() {    
    $('html, body').animate({
        scrollTop: $('.product__info-wrapper .product-form__submit').offset().top - 400
    }, 50);
     $(".product .buy-btn-wrap .main-btn-add").trigger('click');
  });

// setTimeout(function(){ 
//  $('.product__info-wrapper .yotpo-display-wrapper').append('<a  class="review-top-pdp" href="#for-review"></a>');
// }, 5000);
  
const intervalId = setInterval(function () {
    const targetWrapper = $('.product__info-wrapper .yotpo-display-wrapper');
    if (targetWrapper.length) {
        targetWrapper.append('<a class="review-top-pdp" href="#for-review"></a>');
        clearInterval(intervalId); 
    }
}, 500);

// function removeCartItemDetails() {
//   if ($('.progress-free-pro').length > 0) {
//     $('.progress-free-pro .cart-item__details_right').remove();
//   }
// }
// removeCartItemDetails();
// setInterval(removeCartItemDetails, 1000); 

$('.product_video_slider').slick({
   slidesToShow: 5,
   slidesToScroll: 1,
   infinite:false,
   dots:false,
   arrows:true,
   responsive: [
     {
      breakpoint: 1350,
      settings: {
        slidesToShow: 4,
        dots:true
        
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        dots:true
        
      }
    },
       {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        dots:true
        
      }
    },
       {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        dots:true
        
      }
    },
       {
      breakpoint: 481,
      settings: {
        slidesToShow: 1.1,
        dots:true
        
      }
    }
       ]
  });
  
  $(document).on('click','.v_play_btn',function() {   
     var v_id = $(this).data('video');
    $(this).parent().addClass('video-play');
    $(this).parent().append($('#'+v_id));
    let iframeSrc = $(this).parent().find('iframe').attr('src');    
    $(this).parent().find('iframe').attr('src', iframeSrc + '?autoplay=1&color=white&state=1&modestbranding=1&loop=0');
    
  //  $(this).parent().find('video')[0].play();
 //   $('#'+v_id).show();   
  //  $('#'+v_id).find('video')[0].play();
  });
  
  $(document).on('click','.video_modal_close',function() {
     $('.product_video_modal').hide();
    $('.product_video_modal').find('video')[0].pause();
  });

 // yotpo.refreshWidgets();
  $(document).on('click','.active-facets__button-remove',function() {
    setTimeout(function() {
          yotpo.refreshWidgets();
      }, 1500);
  });


  $(document).on('click','.mobile-facets__open',function() {
    setTimeout(function() {   
        $('.mobile-facets__details').each(function () {
          var checklen = $(this).find('input.mobile-facets__checkbox:checked').length;
          if(checklen > 0){
            $(this).addClass('menu-opening');
            $(this).parent().addClass('submenu-open');
            $(this).prop('open', true);
          }else{
            $(this).removeClass('menu-opening');
            $(this).parent().removeClass('submenu-open');
            $(this).prop('open', false);
          }
        });
      if($('.mobile-facets__details').hasClass('menu-opening')){        
       $('.mobile-facets__header-inner .mobile-facets__clear-wrapper').show();
      }else{
         $('.mobile-facets__header-inner .mobile-facets__clear-wrapper').hide();  
         $('.mobile-facets__details').removeClass('menu-opening');
         $('.mobile-facets__main').removeClass('submenu-open');
         $('.mobile-facets__details').removeClass('open', false);   
      }
      }, 500);
 });

  $(document).on('click','.cart-summary-click',function () {
     $(this).parent().toggleClass('open'); 
     $(this).children('span').text($(this).children('span').text() === 'Show Details' ? 'Hide Details' : 'Show Details');
     $(this).parents('.total-total-drawer').next().toggle();
  });

  $(document).on('click','.slider-products-drawer h2',function () {
     $(this).toggleClass('open');     
     $(this).next().toggle();
     $('.cart_product.new-product-item').slick('refresh');    
  });
      
  if ($(window).width() < 751) {
    $(".new-form").attr("id","FacetFiltersForm");
  }
  if (window.location.href.indexOf("/cart") > -1) {
    window.location = "/";
  }
  $(document).on('click','.bestfor_content.content-with-collaps-best',function () {
    $(this).toggleClass("active-toggle");
    $(".content-data-bestfor").slideToggle();
  });
  // if ($(window).width() < 751) {
  // $()
  //   $('.product .icon-with-text').slick({
  //  slidesToShow: 2.5,
  //  slidesToScroll: 1,
  //  infinite:false,
  //  dots:true,
  //  arrows:false
   
  //   });
  // }
  
});
// cart drawer

// $(document).ready(function(){
//   Rebuy.SmartCart.hide();
// })

$(document).on('click' ,'.buy-btn-wrap .product-form__buttons .product-form__submit ,main .gift-sets .quick-add__submit, #product-grid .product-card-wrapper .card__content .quick-add_col_submit,main .collection .quick-add_col_submit,.related-products .quick-add .quick-add__submit', function(event) {
    event.preventDefault();
  var form = $(this).closest('form');
    var formData = form.serialize();
   $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function(response) {
            Rebuy.SmartCart.show();
            setTimeout(function() { 
              if($('.rebuy-cart__flyout #is-a-gift').length == 0){
                $('.rebuy-cart__notes').before($('#is-a-gift'));
              }
            }, 1500);
        },
        error: function(xhr, status, error) {
            console.log('Error adding items to cart:', error);
        }
    });
});